export default __webpack_public_path__ + "static/media/top_companies_ico.0d8faf59.svg";